// Single source of truth untuk PROMO RAYA — Flow Ultra (Sharing) add-on.
//
// Konsep: masa user BARU subscribe SESAAT (RM199), dia boleh tambah akaun
// Flow Ultra (Sharing) untuk RM49 sekali bayar (harga biasa RM100).
//   - Add-on = bayar SEKALI (one-time). Renewal SESAAT kekal RM99 — tak terjejas.
//   - Hanya untuk user BARU (bukan renewal).
//   - Terhad 36 slot. Slot ditolak masa user SUBMIT bukti bayaran (bukan masa
//     admin approve) — supaya tak terlebih jual semasa menunggu pengesahan.
//
// Counter slot disimpan dalam Firestore: promos/{FLOW_PROMO.docId}
//   { slotsTotal: number, slotsUsed: number, active: boolean }
// PricingView & StartGate baca doc ni untuk papar "X / 36 slot tinggal" dan
// auto-tutup pilihan bila slot habis. Naik counter guna increment(1) bila submit.
//
// Flow Ultra (Sharing) = akaun Google Labs Flow yang dikongsi — admin beri akses
// secara manual via WhatsApp selepas pengesahan bayaran. Tiada "akses" dalam app
// yang perlu dibina; promo ni cuma kutip bayaran + tanda submission + kira slot.

export const FLOW_PROMO = {
  docId: 'raya_flow_2026',   // Firestore: promos/raya_flow_2026
  baseSen: 19900,            // RM199 — harga SESAAT bulan pertama (tak berubah)
  priceSen: 4900,            // RM49  — harga promo add-on Flow
  normalPriceSen: 10000,     // RM100 — harga biasa Flow (untuk papar "jimat RM51")
  defaultSlotsTotal: 36,     // fallback kalau doc Firestore belum wujud
};

// Kira jumlah akhir (sen) ikut sama ada add-on Flow dipilih.
export function computeAmountSen(baseSen, withFlowAddon) {
  return baseSen + (withFlowAddon ? FLOW_PROMO.priceSen : 0);
}

// Format sen → "RM248.00"
export function formatSenToRM(sen) {
  return `RM${(sen / 100).toFixed(2)}`;
}
